import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { TextViewe6rp77b08kos as TextView } from './TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  get_H5Semantic2z0efuo572r3d as get_H5Semantic,
  get_H4Semantic111wmmqwoslob as get_H4Semantic,
} from '../../models/Theme.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './LinearLayouts.commonHtml.mjs';
import { weight31wqab1913ly4 as weight } from './modifiers.commonHtml.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { Button263cw152yl80e as Button } from './Button.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../helpers.mjs';
import { onClick3gjrd4jjo1cak as onClick } from './Button.mjs';
import { dialog3sxbjr735jrum as dialog } from '../l2/popoverHelpers.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function h1(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function text(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function subtext(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function confirmDanger(_this__u8e3s4, title, body, actionName, cancelName, action) {
  actionName = actionName === VOID ? 'OK' : actionName;
  cancelName = cancelName === VOID ? 'Cancel' : cancelName;
  dialog(_this__u8e3s4, true, ($this$dialog, closer) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$dialog.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$dialog.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h2(element, title);
    text(element, body);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_0 = weight(element_0, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(this_0, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    text(get_centered(element_1), cancelName);
    onClick(element_1, VOID, VOID, VOID, confirmDanger$lambda$slambda(closer));
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.danger' call
    var this_2 = weight(element_0, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(this_2, DangerSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_4.willAddChild_hz2iwc_k$(element_2);
    text(get_centered(element_2), actionName);
    onClick(element_2, actionName, VOID, VOID, confirmDanger$lambda$slambda_0(action, closer));
    element_2.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_2);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    $this$dialog.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function h2(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function h5(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.h5' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H5Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function h4(_this__u8e3s4, text, align) {
  align = align === VOID ? null : align;
  // Inline function 'com.lightningkite.kiteui.views.direct.h4' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H4Semantic())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = element.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(text) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = text;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element.set_align_ypalx0_k$(align);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function confirmDanger$lambda$slambda($closer) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $closer();
    return Unit_instance;
  }), 0);
}
function confirmDanger$lambda$slambda_0($action, $closer) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($action($completion), $completion);
    $closer();
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  confirmDanger as confirmDanger3l3hm6j4w4gpl,
  h1 as h12aidul0n4qlwh,
  h2 as h2ld0l0a2c9zpb,
  h4 as h42yee57ysxgrns,
  h5 as h52wvgssab93if0,
  subtext as subtext2yjmf1ok7kb40,
  text as text189ciz0cnr32o,
};
//endregion

//# sourceMappingURL=shortcuts.mjs.map
